import {useTranslation} from 'react-i18next';
import {translations} from '../../../i18n/translations';
import {ComboActions} from '../../combo-actions/combo-actions';
import {Pallete} from '../../../theme/bluebird';
import {FiEdit, FiTrash2} from 'react-icons/fi';
import SaveIcon from '@mui/icons-material/SaveAlt';
import {Box} from '@mui/material';

type CardActionsProps = {
  editMode: boolean;
  id?: string;
  setEditMode: (value?: string) => void;
  setConfirmDeletion: (value: boolean) => void;
  onSaveAsPdf?: () => void;
  onSaveAsXlsx?: () => void;
};

export const CardActions = ({
  editMode,
  id,
  setEditMode,
  setConfirmDeletion,
  onSaveAsPdf,
  onSaveAsXlsx,
}: CardActionsProps) => {
  const {t} = useTranslation();

  const actions = [
    {
      label: t(translations.activities_group_entry.actions.edit),
      icon: {element: FiEdit},
      callback: () => setEditMode(id),
    },
    {
      label: t(translations.activities_group_entry.actions.delete),
      icon: {element: FiTrash2},
      callback: () => setConfirmDeletion(true),
    },
    ...(onSaveAsPdf
      ? [
          {
            label: t(translations.office.generics.save_pdf),
            icon: {element: SaveIcon},
            callback: onSaveAsPdf,
          },
        ]
      : []),
    ...(onSaveAsXlsx
      ? [
          {
            label: t(translations.office.generics.save_xlsx),
            icon: {element: SaveIcon},
            callback: onSaveAsXlsx,
          },
        ]
      : []),
  ];

  return (
    <Box className="card-actions">
      {!editMode ? (
        <ComboActions
          className="actions"
          wrapperSX={{color: Pallete.gray.light, display: 'flex', justifyContent: 'flex-end'}}
          triggerSX={{height: '32px', width: '32px'}}
          actions={actions}
        />
      ) : (
        <h5 className="exit-edit-mode" onClick={() => setEditMode()}>
          {t(translations.activities_group_entry.actions.exit)}
        </h5>
      )}
    </Box>
  );
};
